// 45R: Image protection - CSS and JavaScript combined

// Skip in Shopify Customizer (design mode) to prevent preview conflicts
if (window.Shopify && window.Shopify.designMode) {
  // Do not run — customizer needs full pointer-events and keyboard access
} else {

// CSS injection for image protection
const protectionStyles = document.createElement('style');
protectionStyles.textContent = `
  /* 45R: Disable image selection and dragging */
  img {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }

  /* Re-enable pointer events for clickable images */
  img[onclick], 
  .clickable-image img,
  .product-media img,
  .slideshow img {
    pointer-events: auto;
  }
`;
document.head.appendChild(protectionStyles);


// Disable development shortcuts
document.addEventListener('keydown', function(e) {
  // F12
  if (e.key === 'F12') {
    e.preventDefault();
    return false;
  }
  
  // Ctrl+Shift+I (DevTools)
  if (e.ctrlKey && e.shiftKey && e.key === 'I') {
    e.preventDefault();
    return false;
  }
  
  // Ctrl+Shift+C (Inspect)
  if (e.ctrlKey && e.shiftKey && e.key === 'C') {
    e.preventDefault();
    return false;
  }
  
  // Ctrl+U (View Source)
  if (e.ctrlKey && e.key === 'u') {
    e.preventDefault();
    return false;
  }
});

} // end designMode guard